import React from "react";
import Modal from 'components/Modal'
import moment from 'moment'
import { Link, IndexLink } from 'react-router'
import swal from "sweetalert2"
import Scrollbar from 'react-scrollbars-custom';
import { smoothScroll, formatNumber, img, commingSoonFnc, isStartEvent } from 'components/common'
export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      history: null,
      reward_list_spin: null,
      reward_list_ex: null,
    }
  }
  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.parentProp.home.history != null && !nextProps.parentProp.home.loading) {
      this.setState({
        history: nextProps.parentProp.home.history,
      })
    }
    if (nextProps.parentProp.home.reward_list_ex != null && !nextProps.parentProp.home.loading) {
      this.setState({
        reward_list_ex: nextProps.parentProp.home.reward_list_ex,
      })
    }
    if (nextProps.parentProp.home.reward_list_spin != null && !nextProps.parentProp.home.loading) {
      this.setState({
        reward_list_spin: nextProps.parentProp.home.reward_list_spin,
      })
    }
  }
  handleClosePopup() {
    this.setState({ modal: null })
    $('body').removeClass('modal-open');
  }
  handleOpenPopup(modal) {
    this.setState({ modal: modal })
    $('body').addClass('modal-open');
  }
  commingSoon() {
    swal({
      title: 'Thông báo',
      html: '<p class="pop-content">Sự kiện sẽ bắt đầu vào 11h00 ngày 30/10/2019</p>',
      animation: false,
      confirmButtonText: 'Đóng',
      customClass: 'custom-modal animated zoomIn'
    })
    return
  }
  reloadFC() {
    this.props.parentProp.reloadFC()
  }
  handleViewHistory() {
    if (!this.props.parentProp.home.login) {
      swal({
        title: 'Thông báo',
        html: '<p class="pop-content">Bạn cần đăng nhập để tham gia sự kiện.</p>',
        confirmButtonText: 'Đóng',
        animation: false,
        customClass: 'custom-modal animated zoomIn'
      }).then((result) => {
        window.location.href = "/user/login"
      })
      return
    }
    this.props.parentProp.getHistory()
    this.handleOpenPopup('history')
  }
  mapEvenStatus(status) {
    if (!status) { return }
    let eventStatus;
    switch (status) {
      case 1:
        eventStatus = 'Đang xử lý'
        break;
      case 2:
        eventStatus = 'Đã gửi'
        break;
      case 3:
        eventStatus = 'Đang xử lý'
        break;
      case 4:
        eventStatus = 'Đang xử lý'
        break;
      case 5:
        eventStatus = 'Đang xử lý'
        break;
      default:
        break;
    }
    return eventStatus
  }
  render() {
    let { currentUser } = this.props;
    const { modal, history, reward_list_spin, reward_list_ex } = this.state
    return (
      <React.Fragment>
        <header>
          <div className="collapse" id="navbarSupportedContent">
            <ul className="menu">
              <li className="nav-item logo">
                <a className="nav-link" href="https://fo4.garena.vn/"><img src="images/logo.png" alt="" /></a>
              </li>
              <li className="menu-sub">
                <ul>
                  <li>
                    <a href="javascript:void(0)" onClick={e => smoothScroll('.sec-discovery')}><span> trang chủ</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" onClick={e => this.handleOpenPopup('rule')}><span>hướng dẫn</span></a>
                  </li>
                  <li>
                    <a className="buttonSpin" href="javascript:void(0)" onClick={e => this.handleViewHistory()}><span> lịch sử</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" onClick={e => this.handleOpenPopup('rule-pop')}><span> quà</span></a>
                  </li>
                  {
                    currentUser.login &&
                    <React.Fragment>
                      <li className="user">
                        <a href="javascript:void(0)" className="txt-user">
                          <span>Hi <b> {currentUser.user.nickname}</b></span>
                        </a>
                      </li>
                    </React.Fragment>
                  }
                  <li className="action-l-group">
                    {!currentUser.login ? (
                      <React.Fragment>
                        <a className="action" href="/user/login"><span>ĐĂNG NHẬP</span></a>
                        {/* <a className="action" href="javascript:void(0)" onClick={e => this.commingSoon()}><span>ĐĂNG NHẬP</span></a> */}
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          <a className="action" href="/user/logout"><span>đăng xuất</span></a>
                        </React.Fragment>
                      )}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </header>
        <Modal show={modal === 'rule-pop'} customClass={'pop-xs'} closeHandler={() => this.handleClosePopup()}>
          <h3 className="md-header">danh sách quà</h3>
          <div className="gift-recevice">
            <div className="g-title">
              {img('images/md-gift-1.png')}
            </div>
            <div className="list-gift">
              <ul>
                {reward_list_ex &&
                  <React.Fragment>
                    {
                      reward_list_ex.map((reward, index) => (
                        <li key={index} data-tip={reward.item_name}>
                          <label htmlFor="">{reward.hurdle} vòng</label>
                          <img src={reward.item_url} alt={reward.item_name} />
                          <p className="point">{reward.item_name}</p>
                        </li>
                      ))
                    }
                  </React.Fragment>
                }
              </ul>
            </div>
          </div>
          <hr className="hr-yl"/>
          <div className="gift-recevice">
            <div className="g-title">
              {img('images/md-gift-2.png')}
            </div>
            <div className="list-gift">
              <ul>
                {reward_list_spin &&
                  <React.Fragment>
                    {
                      reward_list_spin.map((reward, index) => (
                        <li key={index} data-tip={reward.item_name}>
                          <img src={reward.item_url} alt={reward.item_name} />
                          <p className="point">{reward.item_name}</p>
                        </li>
                      ))
                    }
                  </React.Fragment>
                }
              </ul>
            </div>
          </div>
        </Modal>
        <Modal show={modal === 'history'} customClass={''} closeHandler={() => this.handleClosePopup()}>
          <div className="fire-success">
            <h3 className="md-header">lịch sử quay</h3>
            <div className="pop-body-history">
              <Scrollbar className={`top-all-content`} translateContentSizesToHolder={true}>
                <table className="tbl-history">
                  <thead>
                    <tr>
                      <th>stt</th>
                      <th>tên vật phẩm</th>
                      <th>thời gian</th>
                      <th>trạng thái</th>
                      <th>Sự kiện</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      history &&
                      history.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.item_name}</td>
                          <td>{item.create_time}</td>
                          <td>{this.mapEvenStatus(item.status)}</td>
                          <td>
                            {item.event == 2 ? (
                              <span>Quà tích lũy</span>
                            ) : (

                                <React.Fragment>
                                  {
                                    item.is_free == 1 ? (
                                      <span>Vòng quay Miễn Phí</span>
                                    ) : (
                                        <span>Vòng quay FC</span>
                                      )
                                  }
                                </React.Fragment>
                              )}
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </Scrollbar>
            </div>
          </div>
        </Modal>
        <Modal show={modal === 'rule'} customClass={'modal-history'} closeHandler={() => this.handleClosePopup()}>
          <div className="text-left">
            <h3 className="md-header"> <span>HƯỚNG DẪN</span> </h3>
            <br />
            <br />
            <div className="rule">
              <div className={"text-uppercase green"}>1. THỜI GIAN DIỄN RA SỰ KIỆN</div>
              <ul>
                <li>Từ ngày 06/11/2019 - 23h59 ngày 25/11/2019</li>
              </ul>
              <div className={"text-uppercase green"}>2. HƯỚNG DẪN CHƠI</div>
              <div>- Mỗi lượt quay Vòng quay sẽ mang đến cho các HLV một phần quà giá trị, giá mỗi lượt quay như sau:</div>
              <ul>
                <li>20 FC = 1 Lượt</li>
                <li>190 FC = 10 Lượt</li>
                <li>900 FC = 50 Lượt</li>
              </ul>
              <div>- Bạn còn có thể làm nhiệm vụ để nhận lượt quay hoàn toàn miễn phí. Mỗi ngày bạn sẽ có 2 nhiệm vụ tương đương với 2 lượt quay. Các bước thực hiện để nhận lượt quay: </div>
              <ul>
                <li>Bước 1: Đăng nhập vào trang https://superspin.fo4.garena.vn/ và ấn <b>Nhận nhiệm vụ</b></li>
                <li>
                  <span> Bước 2: Hoàn thành các nhiệm vụ sau</span>
                  <ul>
                    <li>Nhiệm vụ 1: Đăng nhập vào game (Chỉ tính trên PC - Cập nhật sau 5p)</li>
                    <li>Nhiệm vụ 2: Thắng một trận bất kỳ (Không tính đá với bạn và mô phỏng)</li>
                  </ul>
                </li>
                <li>Bước 3: Sau khi hoàn thành nhiệm vụ ấn <b>Cập nhật</b> để hệ thống cập nhật lượt quay.</li>
              </ul>
              <div>- <b>Lưu ý:</b></div>
              <ul>
                <li>Phải ấn Nhận nhiệm vụ trước khi làm nhiệm vụ để hệ thống xác nhận cho bạn.</li>
                <li>Nhiệm vụ sẽ reset mỗi ngày</li>
              </ul>
              <p>Bên cạnh việc nhận quà trực tiếp từ Vòng Quay, các HLV còn có thể nhận thêm phần quà tích lũy bằng việc hoàn thành một số lượng Vòng Quay nhất định. Hãy tích lũy cho mình thật nhiều vòng quay đê rinh về những phần quà hấp dẫn đó nhé!</p>
              <div>- <b>Lưu ý:</b> Quà tích lũy chỉ nhận 1 lần trong suốt sự kiện</div>
            </div>

          </div>
        </Modal>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/Header.js